<div class="">
  <div class="">
    <button class="mat-dialog__close-icon"><app-icon anchor="icon-close-xs" mat-dialog-close></app-icon></button>
    <header class="mb-3 mat-dialog__header">
      <h1 class="h3 mb-1" *ngIf="data.title || (data.prefix + '-titel' | fromDictionary)">
        {{ data.title || (data.prefix + '-titel' | fromDictionary) }}
      </h1>
      <p *ngIf="data.text || (data.prefix + '-titel' | fromDictionary: false)">{{ data.text }}</p>
    </header>

    <mat-dialog-content class="mb-0 pb-0">
      <ul class="order-list">
        <li class="order-list__header d-none d-md-table-row">
          <span>{{ 'label-product' | fromDictionary }}</span>
          <span class="order-list--hide-mobile">{{ 'label-SKU' | fromDictionary }}</span>
          <span class="order-list--hide-mobile">{{ 'label-prijs' | fromDictionary }}</span>
          <span class="order-list--hide-mobile">{{ 'label-aantal' | fromDictionary }}</span>
          <!-- <span>{{ 'label-totaalprijs-kort' | fromDictionary }}</span> -->
        </li>
        <li class="order-list__item" *ngFor="let line of data.order.lineItems">
          <app-order-product-list-item
            [type]="'edit'"
            class=""
            [line]="line"
            (newLine)="handleLineUpdate($event)"
            [variant]="getVariant(line)"
          ></app-order-product-list-item>
        </li>
      </ul>
    </mat-dialog-content>

    <mat-dialog-actions class="mt-2">
      <button class="button button--secondary button-outline" (click)="closeDialog(false)">{{ 'annuleren' | fromDictionary }}</button>

      <div class="ms-auto d-flex align-items-center">
        <span class="d-inline-block me-2 type-body-sm">
          {{ totalCount }} {{ data.prefix + '-aantal-geselecteerd-suffix' | fromDictionary }}
        </span>
        <button class="button button--secondary" (click)="closeDialog(true)">
          {{ (data.prefix + '-toevoegen-aan-winkelwagen' | fromDictionary: false) || ('toevoegen-aan-winkelwagen' | fromDictionary) }}
        </button>
      </div>
    </mat-dialog-actions>
  </div>
</div>
